import React from 'react';
import { FirebaseProvider } from './src/contexts/firebaseContext';
import { HeadFC } from "gatsby";



// This gatsby-browser.tsx file will only be run on the browser.
export const wrapRootElement = ({ element }) => (
  <FirebaseProvider>{element}</FirebaseProvider>
);
